<template>
    <loading-indicator v-if="loading"/>
    <div v-else>
        <template v-if="participants.length">
            <person-box-user v-for="user in participants" :id="user" :key="'chat-read-' + user" />
        </template>
        <template v-else><em class="text-grey">Die Nachricht wurde noch von keinem gelesen.</em></template>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator';
    import {errorHandler} from '../../utils/portuna';
    import LoadingIndicator from '../LoadingIndicator.vue';
    import PersonBoxUser from '../PersonBoxUser.vue';

    @Component({
        name: 'AppChatMessageReadPopup',
        components: {
            LoadingIndicator,
            PersonBoxUser},
    })
    export default class AppChatMessageReadPopup extends Vue
    {
        @Prop({
            type: Number,
            required: true,
        }) messageId: number;

        loading = true;

        participants: number[] = [];

        created()
        {
            this.axios.get('/chat/chat/fetch-message-data/id/' + this.messageId)
            .then(({data: {data}}) =>
            {
                this.participants = data.participants;
                this.loading = false;
                this.emitter.emit('lazy-load-focus');
            })
            .catch((reason) =>
            {
                errorHandler(reason);
                this.emitter.emit('close');
            });
        }
    }
</script>